module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "order_toolbar toolbar pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('p', {
    staticClass: "goodslist1",
    staticStyle: {
      "margin": "0",
      "margin-left": "-22px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "31px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "-19px",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }],
    staticStyle: {
      "padding": "0px 12px"
    }
  }, [_c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "关键词语："
    }
  }, [_c('el-input', {
    staticStyle: {
      "overflow": "hidden",
      "text-overflow": "ellipsis",
      "white-space": "nowrap"
    },
    attrs: {
      "title": _vm.filters.keyword,
      "placeholder": "商品编码 / 标题",
      "maxlength": "50"
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select letter",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "品 牌 商："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "options": _vm.options3,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.filters.pinpaishang),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pinpaishang", $$v)
      },
      expression: "filters.pinpaishang"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "商品品类："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getbrandarr
    },
    model: {
      value: (_vm.filters.brandTypeId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandTypeId", $$v)
      },
      expression: "filters.brandTypeId"
    }
  }, _vm._l((_vm.brandTypearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "商品品牌："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.brandId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandId", $$v)
      },
      expression: "filters.brandId"
    }
  }, _vm._l((_vm.brandarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "20px"
    },
    attrs: {
      "label": "商品状态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.statusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "statusId", $$v)
      },
      expression: "filters.statusId"
    }
  }, _vm._l((_vm.statusptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "20px"
    },
    attrs: {
      "label": "销售类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.goodsActiveId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "goodsActiveId", $$v)
      },
      expression: "filters.goodsActiveId"
    }
  }, _vm._l((_vm.goodsActiveOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "order_content main_container",
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品数据分析")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "table_inner_container",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('el-table', {
    staticClass: "invoice_tab",
    staticStyle: {
      "height": "auto",
      "max-height": "500px"
    },
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "产品型号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodModelCode,
            "label": scope.row.GoodModelCode
          }
        }, [_vm._v(_vm._s(scope.row.GoodModelCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Title,
            "label": scope.row.Title
          }
        }, [_vm._v(_vm._s(scope.row.Title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属品类",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BrandTypeName,
            "label": scope.row.BrandTypeName
          }
        }, [_vm._v(_vm._s(scope.row.BrandTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BrandName,
            "label": scope.row.BrandName
          }
        }, [_vm._v(_vm._s(scope.row.BrandName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "甄惠装价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.TzrPrice,
            "label": scope.row.TzrPrice
          }
        }, [_vm._v(_vm._s(scope.row.TzrPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "浏览数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap",
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          attrs: {
            "title": scope.row.BrowseCount,
            "label": scope.row.BrowseCount
          },
          on: {
            "click": function($event) {
              return _vm.endViews(scope)
            }
          }
        }, [_vm._v(_vm._s(scope.row.BrowseCount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收藏数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap",
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          attrs: {
            "title": scope.row.CollectionCount,
            "label": scope.row.CollectionCount
          },
          on: {
            "click": function($event) {
              return _vm.endCollections(scope)
            }
          }
        }, [_vm._v(_vm._s(scope.row.CollectionCount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "购物车数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.ShopCartCount,
            "label": scope.row.ShopCartCount
          }
        }, [_vm._v(_vm._s(scope.row.ShopCartCount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.PlaceOrderCount,
            "label": scope.row.PlaceOrderCount
          }
        }, [_vm._v(_vm._s(scope.row.PlaceOrderCount))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "order_toolbar_footer",
    staticStyle: {
      "margin-top": "15px",
      "float": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.dialogTable,
      "before-close": _vm.cancelForm,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTable = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v(_vm._s(_vm.record))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": _vm.cancelForm
          }
        }, [_vm._v("关 闭")])], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawer_div"
  }, [_c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.gridData,
      "height": "800"
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "UserName",
      "label": "用户名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "CTime",
      "label": _vm.labelName,
      "align": "center"
    }
  }), _vm._v(" "), _c('template', {
    slot: "append"
  }, [_c('div', {
    staticClass: "scrollingTips"
  }, [(_vm.loading) ? _c('p', [_vm._v("正在加载")]) : _vm._e(), _vm._v(" "), (_vm.noMore) ? _c('p', [_vm._v("没有更多了")]) : _vm._e()])])], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39db7f4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/goodsAnalysis.vue
// module id = 1677
// module chunks = 3